<template>
  <div class="main">
    <div class="header">
      <NavBar_phone></NavBar_phone>
      <div class="title">自动化+高效+智能为制造赋能</div>
      <div class="txt">
        Automation<br />+<br />Efficiency<br />+<br />Intelligence
      </div>
      <div class="txt">Empowering<br />Manufacturing</div>
      <img class="banner" src="@/assets/img/banner.png" />
    </div>
    <Card_phone>
      <template v-slot:title>公司介绍</template>
      <template v-slot:banner
        ><img src="@/assets/img/gongsijieshao_phone.png"
      /></template>
      <template v-slot:body>
        <div class="CompanyProfile">
          <div class="head">上海奕盛软件有限公司</div>
          <div class="label">卓越创新</div>
          <div class="txt">
            自2000年创建以来,以坚韧的努力和追求卓越的精神不断创新，致力于为中国地区的制造商提供完整的企业管理及IT解决方案帮助打造高效企业迎接全球化发展带来的挑战，并以优良的技术和完美的服务，赢得众多外资与本地客户的信赖。我们高度关注汽车、生命科学、电子、食品饮料和消费品等垂直行业的发展并基于信息简单、自动化等原则协助该行业领域内的制造商
          </div>
          <div class="label">高效管理</div>
          <div class="txt">
            作为全球化之下的制造商追求的目标，是先进制造商标志之一，我们基于企业数据平台帮助制造商达成以下高效运营目标：
          </div>
          <ul>
            <li
              v-for="(item, index) in CompanyProfile"
              :key="index"
              class="list"
            >
              <img src="@/assets/img/juxin19.png" />
              <div>{{ item }}</div>
            </li>
          </ul>
        </div>
      </template>
    </Card_phone>
    <Card_phone>
      <template v-slot:title>总体方案</template>
      <template v-slot:body>
        <div class="CompanyProfile">
          <div class="txt">
            公司基于ERP核心，衍生后ERP时代打造企业数字化，智能化管理，构建一体化解决方案体系，整合软硬件协同的专业咨询服务，协助制造业建立企业级大数据，借助云计算、机器学习、数据湖、机器流程自动化RPA
            、IoT物联网等先进信息技术手段，走向智能工厂
          </div>
          <img src="@/assets/img/image.png" />
        </div>
      </template>
    </Card_phone>
    <Card_phone>
      <template v-slot:title>行业方案</template>
      <template v-slot:body>
        <div
          class="IndustrySolutions"
          v-for="(item, index) in IndustrySolutions"
          :key="index"
        >
          <img :src="item.img_src" />
          <div class="label">{{ item.label }}</div>
          <div class="txt">{{ item.txt_1 }}</div>
          <div style="width: 80%">
            <el-button @click="$router.push('/IndustrySolutions_phone')"
              ><i class="el-icon-arrow-right"></i>查看更多</el-button
            >
          </div>
        </div>
      </template>
    </Card_phone>
    <Card_phone>
      <template v-slot:title>客户案例</template>
      <template v-slot:body>
        <div
          class="IndustrySolutions"
          v-for="(item, index) in CustomerStories"
          :key="index"
        >
          <div class="banner"><img :src="item.img_src" /></div>
          <div class="label">{{ item.label }}</div>
          <div class="label_en">{{ item.EN_label }}</div>
          <div class="txt">{{ item.txt }}</div>
        </div>
      </template>
    </Card_phone>
    <Card_phone>
      <template v-slot:title>培训服务</template>
      <template v-slot:body>
        <div class="TrainingServe">
          <div class="head">
            <img src="@/assets/img/vector.png" />
          </div>
          <div class="label">QAD模块培训</div>
          <div class="txt">QAD标准模块培训</div>
        </div>
        <div class="TrainingServe">
          <div class="head">
            <img src="@/assets/img/vector.png" />
            <el-link
              style="color: #2f54eb"
              @click="$router.push('/TrainingServe_phone')"
              ><i class="el-icon-right"></i>查看更多</el-link
            >
          </div>
          <div class="label">QAD模块培训</div>
          <div class="txt">QAD标准模块培训</div>
        </div>
      </template>
    </Card_phone>
    <Card_phone>
      <template v-slot:title>关于我们</template>
      <template v-slot:body>
        <div class="AboutUs">
          <div style="display: flex; justify-content: center;">
            <img src="@/assets/img/ESUN_SITE.png" style="width: 80%; margin: 3rem 0" @click="toBaiduEsunSite()">
          </div>
          <!-- <div id="container" style="width: 100%; height: 8rem"></div> -->
          <div class="bottom">
            <div class="label">公司地点</div>
            <div class="txt">
              上海市闵行区浦江镇联航路1588号国家现代服务业软件产业基地SOHO研发楼第8幢
            </div>
            <div class="label">联系我们</div>
            <div class="txt">021-53015840</div>
            <div class="txt">sales@esun.sh.cn</div>
            <div class="txt">support@esun.sh.cn</div>
          </div>
        </div>
      </template>
    </Card_phone>
    <Footer_phone></Footer_phone>
  </div>
</template>
  
  <script>
import NavBar_phone from "@/components/NavBar_phone.vue";
import Footer_phone from "@/components/Footer_phone.vue";
import Card_phone from "@/components/Card_phone.vue";
import car from "@/assets/img/car_phone.png";
import life from "@/assets/img/science_phone.png";
import Au from "@/assets/img/Vutoliv_phone.png";
import logo1 from "@/assets/img/ARN_phone.png";
import ccc from "@/assets/img/Med.png";
export default {
  name: "HomeView",
  components: {
    NavBar_phone,
    Card_phone,
    Footer_phone,
  },
  data() {
    return {
      CompanyProfile: [
        "协同、合规与自动化供应链管理",
        "质量＝生命",
        "面向效率与合规的财务管理",
        "自动化业务流程管理",
      ],
      IndustrySolutions: [
        {
          label: "汽车行业",
          txt_1:
            "随着宏观环境的变化，中国汽车产业正步入转型升级的重质量发展时代。在各项战略举措的支持下深化改革，市场环境被显著重塑。",
          txt_2:
            "汽车行业高管将数字化转型作为优先举措，40%的受访企业已从数字化转型中实现了显著的投资回报率，逾半数的受访者计划在来年大幅增加数字化转型方面的投资。在驱动因素方面，尽管生产和运营目标是推动数字化转型最重要的两大因素，而汽车行业则更多地受竞争压力和创新需求的推动。在推动数字化创新的职能部门中，信息技术（IT）部门高居首位，不过供应链、产品设计、市场和规划方面的数字化转型相对成熟，这也将继续成为未来投资的优先领域。",
          img_src: car,
        },
        {
          label: "生命科学",
          txt_1:
            "在过去几年中，中国国内医药消费增长迅猛，医药行业销售收入平均年增长达21.4%。受强劲的经济增长、不断加剧的城市化进程以及老龄化带来的就医需求等因素的驱动，中国将成为世界最大的医药市场之一。到2020年，中国的医药市场销售额预计达到2200亿美元，中国将成为仅次于美国的世界第二大医药市场。",
          img_src: life,
        },
      ],
      CustomerStories: [
        {
          label: "奥托立夫",
          EN_label: "AUTOLIV",
          txt: "通过ERP系统定制开发，实现了管理的标准化，资源的共享和流程的标准化。助力奥托立夫全球化扩张。",
          img_src: Au,
        },
        {
          label: "安庆环新集团",
          EN_label: "ARN",
          txt: "通过车间管理平台系统的定制开发，实现了生产过程条码跟踪，数据采集、监控与防错，减少了管理成本。",
          img_src: logo1,
        },
        {
          label: "苏州美创",
          EN_label: "MEICHUANG",
          txt: "通过QAD系统实施，实现全流程追溯，满足监管要求，通过了TUV13485质量管理体系认证和GSP审核",
          img_src: ccc,
        },
      ],
    };
  },
  methods: {
    toBaiduEsunSite(){
        window.open("https://map.baidu.com/search/%E4%B8%8A%E6%B5%B7%E5%A5%95%E7%9B%9B%E8%BD%AF%E4%BB%B6%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/@13527877,3621420,18z?querytype=s&da_src=shareurl&wd=%E4%B8%8A%E6%B5%B7%E5%A5%95%E7%9B%9B%E8%BD%AF%E4%BB%B6%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8&c=289&src=0&wd2=%E4%B8%8A%E6%B5%B7%E5%B8%82%E9%97%B5%E8%A1%8C%E5%8C%BA&pn=0&sug=1&l=13&b=(13506375,3612771;13555527,3636131)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&sug_forward=735551faf714a5d8c5effbaa&device_ratio=2"); // 新标签页打开目标URL
    },
    mapInit() {
      // 2. 创建地图示例
     
    },
  },
  mounted() {
    // this.mapInit();
  },
};
</script>
  <style lang="scss" scoped>
.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  img {
    display: block;
  }
  .header {
    background-color: #232585;
    height: 40vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    position: relative;
    overflow: hidden;
    padding-bottom: 5vh;
    .title {
      width: 80vw;
      font-family: DingTalk JinBuTi;
      font-size: 1.75rem;
      font-weight: normal;
      color: white;
    }
    .txt {
      color: white;
      font-size: 0.6rem;
      font-family: DingTalk JinBuTi;
      width: 80vw;
    }
    .banner {
      width: 100%;
      display: block;
      position: absolute;
      right: -30vw;
      bottom: -5vh;
    }
  }
}
</style>
  